// Cartão do dashboard -> tipo da meta (spec 159).
export const CARD_GOAL_TYPES = {
  revenue: 'revenue',
  won_count: 'sales_count',
  conversion_rate: 'conversion_rate',
  average_purchase_time_seconds: 'sales_time',
};

export const findTeamGoal = (goals, goalType) =>
  goals.find(goal => goal.scopeType === 'team' && goal.goalType === goalType);

export const findUserGoals = (goals, userId) =>
  goals.filter(
    goal =>
      goal.scopeType === 'user' &&
      userId !== null &&
      goal.assignedUserId === userId
  );
